import { render, staticRenderFns } from "./Circle3.vue?vue&type=template&id=0d1c814a&scoped=true&"
import script from "./Circle3.vue?vue&type=script&lang=js&"
export * from "./Circle3.vue?vue&type=script&lang=js&"
import style0 from "./Circle3.vue?vue&type=style&index=0&id=0d1c814a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1c814a",
  null
  
)

export default component.exports